module.exports = __webpack_public_path__ + "static/media/lotus-flower.f36736d8.png";